import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { COLORS } from '../theme';

interface IProps {
  /** `note`, when set, shows as a hover tooltip on that option — e.g. CTR's clickable-media caveat (flank#4752). */
  options: { key: string; label: string; note?: string }[];
  value: string;
  onChange: (value: string) => void;
}

/** Small orange segmented metric/granularity selector (Impressions / CTR / VCR, etc.). */
const MetricToggle = ({ options, value, onChange }: IProps) => (
  <ToggleButtonGroup
    size='small'
    exclusive
    value={value}
    onChange={(_event, next: string | null) => {
      if (next) onChange(next);
    }}
    sx={{
      '& .MuiToggleButton-root': {
        textTransform: 'none',
        border: 0,
        borderRadius: '8px !important',
        px: 1.25,
        py: 0.25,
        color: COLORS.muted,
        fontSize: 12,
        fontWeight: 600,
        '&.Mui-selected': {
          bgcolor: COLORS.primary,
          color: '#fff',
          '&:hover': { bgcolor: COLORS.primaryHover },
        },
      },
    }}
  >
    {options.map(option =>
      option.note ? (
        <Tooltip key={option.key} title={option.note} placement='top' arrow>
          <ToggleButton value={option.key}>{option.label}</ToggleButton>
        </Tooltip>
      ) : (
        <ToggleButton key={option.key} value={option.key}>
          {option.label}
        </ToggleButton>
      ),
    )}
  </ToggleButtonGroup>
);

export default MetricToggle;
